import { AppShell, Box, type BoxProps } from "@mantine/core";
import type { ReactNode } from "react";

type PortalMainShellProps = BoxProps & {
  children: ReactNode;
};

/** Scroll-safe main content wrapper — prevents horizontal page overflow in portal shells. */
export function PortalMainShell({ children, style, ...rest }: PortalMainShellProps) {
  return (
    <Box
      style={{
        minWidth: 0,
        maxWidth: "100%",
        overflowX: "clip",
        minHeight: "100%",
        ...style,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}

type PortalAppShellMainProps = {
  children: ReactNode;
  style?: React.CSSProperties;
};

/** AppShell.Main with shared overflow guards for authenticated layouts. */
export function PortalAppShellMain({ children, style }: PortalAppShellMainProps) {
  return (
    <AppShell.Main
      style={{
        minWidth: 0,
        overflowX: "clip",
        minHeight: "calc(100dvh - var(--app-shell-header-offset, 0px))",
        ...style,
      }}
    >
      {children}
    </AppShell.Main>
  );
}
